import { useMatches } from "@tanstack/react-router"
import type { ReactNode } from "react"

import { SiteFooter } from "@/routes/-components/site/SiteFooter"
import { SiteHeader } from "@/routes/-components/site/SiteHeader"
import { getRouteHeaderVariant } from "@/routes/-components/site/siteHeaderVariant"

interface PublicLayoutProps {
  children: ReactNode
}

export function PublicLayout({ children }: PublicLayoutProps) {
  const headerVariant = useMatches({ select: getRouteHeaderVariant })

  return (
    <div className="flex min-h-dvh flex-col bg-base text-default">
      {/* Grid rows: header (auto) / routed content (1fr) / footer (auto). The
          1fr body row absorbs leftover viewport height so the footer stays at
          the bottom on short pages — replacing the old empty flex filler. A
          page section can fill the screen simply by growing inside the body
          (see RebellionSignupSection); no min-height or magic flex factor.
          overflow-clip (not hidden) keeps clipping wide artwork without turning
          main into a scroll container, so sticky elements inside pages still
          pin to the viewport. */}
      <main className="relative z-0 grid flex-1 grid-rows-[auto_1fr_auto] overflow-clip">
        <SiteHeader variant={headerVariant} />
        {/* No min-h-0: the 1fr track keeps its content-based minimum so tall
            pages grow the document rather than overflowing and being clipped.
            min-w-0, however, is required: as a grid item this row defaults to
            min-width:auto (its min-content), which was pinning the grid column
            to ~486px and clipping every section on viewports below that. */}
        <div data-page-content className="flex min-w-0 flex-col">
          {children}
        </div>
        <SiteFooter />
      </main>
    </div>
  )
}
